import { useRef, useState } from "react";

import useOnClickOutside from "utils/useOnClickOutside";
import { ArrowUp, ArrowDown } from "components/assets/Icons";
import styles from "./CustomTimePicker.module.scss";

export const CustomTimePicker = ({data, onChange, setIsOpen}) => {
  const containerRef = useRef();
  const [hours, setHours] = useState(new Date(data).getHours());
  const [minutes, setMinutes] = useState(new Date(data).getMinutes());
  const [isAM, setIsAM] = useState(new Date(data).getHours() >= 12 ? 'PM' : 'AM');

  const increaseHours = (e) => {
    e.preventDefault();
    setHours(hours === 12 ? 1 : hours + 1);
    let result = new Date(data).setHours(hours === 12 ? 1 : hours + 1)
    onChange(new Date(result))
  };

  const decreaseHours = (e) => {
    e.preventDefault();
    setHours(hours === 1 ? 12 : hours - 1);
    let result = new Date(data).setHours(hours === 1 ? 12 : hours - 1)
    onChange(new Date(result))
  };

  const increaseMinutes = (e) => {
    e.preventDefault();
    setMinutes(minutes === 59 ? 0 : minutes + 1);
    let result = new Date(data).setMinutes(minutes === 59 ? 0 : minutes + 1)
    onChange(new Date(result))
  };

  const decreaseMinutes = (e) => {
    e.preventDefault();
    setMinutes(minutes === 0 ? 59 : minutes - 1);
    let result = new Date(data).setMinutes(minutes === 0 ? 59 : minutes - 1)
    onChange(new Date(result))
  };

  const toggleAMPM = () => {
    let hours = new Date(data).getHours()
    hours += hours >= 12 ? -12 : 12;
    let result = new Date(data).setHours(hours)
    setIsAM(new Date(result).getHours() >= 12 ? 'PM' : 'AM')
    onChange(new Date(result))
  };

  // useEffect(() => {}, [data])

  useOnClickOutside(containerRef, () => setIsOpen(false));
  return (
    <div className={styles.timepicker_container} ref={containerRef}>
      <div className={styles.timepicker_group}>
        <div onClick={increaseHours}><ArrowUp/></div>
        <span>{hours % 12 || 12}</span>
        <div onClick={decreaseHours}><ArrowDown/></div>
      </div>
      <div className={styles.timepicker_group}>
      :
      </div>
      <div className={styles.timepicker_group}>
        <div onClick={increaseMinutes}><ArrowUp/></div>
        <span>{minutes < 10 ? `0${minutes}` : minutes}</span>
        <div onClick={decreaseMinutes}><ArrowDown/></div>
      </div>
      <div className={styles.timepicker_group_select}>
        <select onChange={toggleAMPM} value={isAM}>
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div> 
  );
};

export default CustomTimePicker
